<template>
  <div class="d-flex">
    <h4 class="toolbar__title">{{product.name_zh_hk}} {{product.volume ? ' - ' + product.volume : ''}}</h4>&nbsp;
    <span class="grey--text caption">{{ product.sku !== product.id ? ' | ' + product.sku : '' }}</span>
  </div>
</template>

<script>
  export default {
    props: {
      product: Object
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/Rental/Locations/Products/LocationProduct/ProductName.vue